<script setup lang="ts">
    import { useStore } from "@/store";
    import { statusar } from "@/tabs/Operation/utils";

    // TODO Skip filter

    const props = withDefaults(
        defineProps<{
            name?: string;
            multiple?: boolean;
            label?: string;
            ignoreEmptyData?: boolean;
            /**
             * Ska filtrering av valbar status göras via inställningar? Default är true. False gör att alla status
             * i dropdown blir valbara.
             */
            useFilter?: boolean;
        }>(),
        {
            name: "status",
            label: "Status",
            useFilter: true,
        }
    );

    const getOptions = () => {
        const store = useStore();

        if (props.useFilter) {
            const anmalanStatuses = store.state.config?.operation?.OPERATION_ANMALAN_STATUSES;

            if (anmalanStatuses?.length) {
                return statusar.filter((status) => anmalanStatuses.includes(status.value));
            }
        }

        return props.useFilter
            ? statusar
            : statusar.map((status) => ({
                  ...status,
                  disabled: false,
              }));
    };
</script>

<template>
    <KAutocomplete
        v-bind="$attrs"
        :name="name"
        :multiple="multiple"
        :options="getOptions"
        :label="label"
        :ignoreEmptyData="ignoreEmptyData"
    />
</template>

<style lang="scss" scoped>
    .status-autocomplete {
    }
</style>
